export default __webpack_public_path__ + "static/media/q30a_v2.fe69929d.png";